var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogin)?_c('HelloWorld'):_c('Login',{on:{"getToken":function($event){_vm.isLogin = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }